export const MODAL_LOGIN = 'LOGIN';
export const MODAL_REGISTER = 'REGISTER';
export const MODAL_ADD_SUB_SYSTEM = 'MODAL_ADD_SUB_SYSTEM';
export const MODAL_DELETE_SUB_SYSTEM = 'MODAL_DELETE_SUB_SYSTEM';
export const MODAL_ADD_MODULE = 'MODAL_ADD_MODULE';
export const MODAL_DELETE_MODULE = 'MODAL_DELETE_MODULE';
